@if (initialized && dto) {
    @if (uiMode == 'side') {
        <im-import-object-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></im-import-object-side>
    } @else {
        <im-import-object-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></im-import-object-full>
    }
}
